"use strict";

exports.__esModule = true;
exports.MultiRoleSelector = MultiRoleSelector;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _icons = require("@blueprintjs/icons");
var _Core = require("../Core");
var _RoleListContext = require("./RoleListContext");
var _excluded = ["onChange", "value"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var rolePredicate = function rolePredicate(query, item) {
  return item.toLowerCase().includes(query.toLowerCase());
};
function MultiRoleSelector(props) {
  var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext.translate;
  var roles = _react["default"].useContext(_RoleListContext.RoleListContext);
  var onChange = props.onChange,
    value = props.value,
    extra = _objectWithoutPropertiesLoose(props, _excluded);
  var rolesNames = roles != null && (roles == null ? void 0 : roles.length) !== 0 ? roles.map(function (role) {
    return role.name;
  }) : [];
  return /*#__PURE__*/_react["default"].createElement(_Core.DropdownCheckboxList, _extends({
    dataTestId: "MultiRoleSelector.selector",
    selected: value == null ? rolesNames : value,
    items: rolesNames,
    itemPredicate: rolePredicate,
    renderItemText: function renderItemText(item) {
      return item;
    },
    getKey: function getKey(item) {
      return item;
    },
    onSelect: function onSelect(e) {
      if (!e || e.length === 0) {
        onChange([]);
        return;
      }
      if (e.length === rolesNames.length) {
        onChange(null);
        return;
      }
      onChange(e);
    },
    icon: _icons.IconNames.BOX,
    placeholder: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "MultiRoleSelector.placeholder",
      defaultMessage: "Select roles"
    }),
    searchPlaceHolder: translate("MultiRoleSelector.search.placeholder", "Search for role")
  }, extra));
}